/* =========================================================
   MonInge — animations du thème
   - Accueil : plugin 3D (360°, démontage, 5 pièces), piloté au défilement
   - Navigation : fondu + arrivée directe sur les parties
   - Apparitions au défilement (flou -> net)
   - Lecteur avant / après avec les vrais extraits audio
   ========================================================= */
(function () {
  'use strict';

  var ease = function (x) { x = x < 0 ? 0 : x > 1 ? 1 : x; return x * x * (3 - 2 * x); };
  var clamp = function (x, a, b) { return Math.max(a, Math.min(b, x)); };
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var designMode = !!(window.Shopify && window.Shopify.designMode);
  var scroller = function () { return document.scrollingElement || document.documentElement; };
  var headerH = function () { var h = document.querySelector('[data-mi-header]'); return h ? h.offsetHeight : 72; };

  /* ---------------------------------------------------------
     Fondu de navigation
     --------------------------------------------------------- */
  var veilTimer = null;
  function withVeil(fn) {
    var veil = document.querySelector('[data-mi-veil]');
    if (!veil || reduced) { fn(); return; }
    veil.classList.add('is-on');
    clearTimeout(veilTimer);
    veilTimer = setTimeout(function () {
      fn();
      requestAnimationFrame(function () { veil.classList.remove('is-on'); });
    }, 220);
  }

  /* Rejoue l'animation d'arrivée d'une partie (alterne deux noms d'animation pour forcer la relecture) */
  function replayArrive(el) {
    if (!el) return;
    var useTwo = !el.classList.contains('mi-arrive2');
    el.classList.remove('mi-wait', 'mi-arrive', 'mi-arrive2');
    el.classList.add(useTwo ? 'mi-arrive2' : 'mi-arrive');
    if (el._miNextMarquees) el._miNextMarquees.forEach(function (m) { m.classList.remove('mi-wait'); m.classList.add('mi-arrive'); });
  }

  function goSection(id) {
    if (id === 'mi-top') {
      withVeil(function () { scroller().scrollTop = 0; });
      return true;
    }
    var el = document.getElementById(id);
    if (!el) return false;
    withVeil(function () {
      var top = el.getBoundingClientRect().top + window.pageYOffset - headerH() + 8;
      window.scrollTo(0, Math.max(0, top));
      replayArrive(el.closest('[data-mi-reveal]') || el);
    });
    return true;
  }

  /* ---------------------------------------------------------
     Accueil : le plugin 3D
     --------------------------------------------------------- */
  var hero = null;

  function Hero(root) {
    var self = this;
    this.root = root;
    this.stage = root.querySelector('[data-mi-stage]');
    this.intro = root.querySelector('[data-mi-intro]');
    this.h1 = this.intro ? this.intro.querySelector('h1') : null;
    this.sub = this.intro ? this.intro.querySelector('.mi-intro__sub') : null;
    this.anchor = root.querySelector('[data-mi-anchor]');
    this.plug = root.querySelector('[data-mi-plug]');
    this.pulse = root.querySelector('[data-mi-pulse]');
    this.d3 = root.querySelector('[data-mi-3d]');
    this.edgesBox = root.querySelector('[data-mi-edges]');
    this.envs = [].slice.call(root.querySelectorAll('[data-mi-env]'));
    this.fade = root.querySelector('[data-mi-fade]');
    this.panels = [].slice.call(root.querySelectorAll('[data-mi-panel]'));
    this.prog = root.querySelector('[data-mi-prog]');
    this.plab = root.querySelector('[data-mi-plab]');
    this.dots = [].slice.call(root.querySelectorAll('[data-mi-dot]'));
    this.nextBtn = root.querySelector('[data-mi-next]');
    this.nextLabel = root.querySelector('[data-mi-nextlabel]');
    this.hint = root.querySelector('[data-mi-hint]');
    this.hintBtn = root.querySelector('[data-mi-hintbtn]');
    this.pieces = {};
    ['face', 'frame', 'pcb', 'hs', 'back', 'backout'].forEach(function (k) { self.pieces[k] = root.querySelector('[data-mi-piece="' + k + '"]'); });
    this.labels = (root.getAttribute('data-labels') || '').split('|');
    this.accents = (root.getAttribute('data-accents') || '').split('|');
    this.nextEnd = root.getAttribute('data-next-end') || '';
    this.CH0 = 0.24; this.CHL = 0.152; this.NCH = 5;
    this.p = 0; this.pT = 0; this.raf = null; this.autoId = 0;
    this.panelArr = [false, false, false, false, false];
    this.fIdx = -1;

    this.layout();
    this.bind();
    this.onScroll();
    this.render(this.p);
  }

  Hero.prototype.layout = function () {
    var vw = window.innerWidth, vh = window.innerHeight;
    // sur téléphone, la barre d'adresse change la hauteur en défilant : on ignore ces petites variations
    if (this.vw === vw && this.vh && Math.abs(vh - this.vh) < 140 && vw < 1000) vh = this.vh;
    this.vw = vw; this.vh = vh;
    this.mob = vw < 1000;
    this.H = clamp(vh, 560, 1100);
    this.hh = headerH();
    this.root.style.height = (this.H + 4600) + 'px';
    this.stage.style.height = this.H + 'px';
    // tranche du boîtier : couches empilées (moins sur téléphone)
    var n = this.mob ? 12 : 30;
    if (this.edgeCount !== n) {
      this.edgesBox.innerHTML = '';
      this.edges = [];
      for (var i = 0; i < n; i++) {
        var d = document.createElement('div');
        d.className = 'mi-edge';
        d.style.transform = 'translateZ(' + (11 - i * (22 / (n - 1))).toFixed(2) + 'px)';
        this.edgesBox.appendChild(d);
        this.edges.push(d);
      }
      this.edgeCount = n;
    }
    // mise en page du titre et du plugin
    var vwv = vw, H = this.H, hh = this.hh;
    var titleSize = Math.round(clamp(Math.min(76, vwv * 0.065, H * 0.085), 34, 76));
    var subSize = vwv < 600 ? 16 : 18;
    var titleTop = Math.round(hh + H * 0.04);
    var subLines = vwv < 600 ? 2 : 1;
    var titleBottom = titleTop + 25 + titleSize * 2.04 + 14 + subSize * 1.5 * subLines;
    var areaTop = titleBottom + 24, areaBottom = H - 76;
    var availH = Math.max(120, areaBottom - areaTop);
    this.startBase = clamp(Math.min(1, (vwv * 0.86) / 860, (availH * 0.88) / 380), 0.28, 1);
    this.plugY = Math.round(areaTop + availH / 2);
    this.cy = Math.round(hh + (H - hh) / 2);
    if (this.intro) this.intro.style.top = titleTop + 'px';
    if (this.h1) this.h1.style.fontSize = titleSize + 'px';
    if (this.sub) this.sub.style.fontSize = subSize + 'px';
    this.anchor.style.top = this.plugY + 'px';
    // position finale du plugin : à gauche (ordi) ou en haut (téléphone)
    if (this.mob) {
      this.endSc = clamp(Math.min((vwv * 0.62) / 860, 0.5), 0.2, 0.5);
      this.endX = 0; this.endY = hh + 20 + 300 * this.endSc;
    } else {
      this.endSc = clamp(Math.min((vwv * 0.4) / 860, (H - 160) / 700, 0.62), 0.3, 0.62);
      this.endX = Math.max(-vwv * 0.22, 32 + 595 * this.endSc - vwv / 2); this.endY = this.cy + 10;
    }
    // emplacement des textes
    var visCx = vwv / 2 + this.endX - 110 * this.endSc, visCy = this.endY - 59 * this.endSc;
    var panelL = Math.round(Math.max(vwv * 0.52, visCx + 485 * this.endSc + 48));
    var panelW = Math.round(Math.max(320, Math.min(520, vwv - panelL - 40)));
    var self = this;
    this.panels.forEach(function (el) {
      if (self.mob) {
        el.style.left = '16px'; el.style.right = '16px'; el.style.width = 'auto'; el.style.maxWidth = '520px'; el.style.margin = '0 auto';
        el.style.top = Math.round(self.endY + 200 * self.endSc + 18) + 'px';
      } else {
        el.style.left = panelL + 'px'; el.style.right = 'auto'; el.style.width = panelW + 'px'; el.style.maxWidth = ''; el.style.margin = '0';
        el.style.top = Math.round(visCy) + 'px';
      }
    });
    this.panelShift = this.mob ? '0px' : '-50%';
  };

  Hero.prototype.progress = function () {
    var r = this.root.getBoundingClientRect();
    var total = r.height - this.H;
    return clamp(-r.top / Math.max(1, total), 0, 1);
  };

  Hero.prototype.onScroll = function () {
    this.pT = this.progress();
    this.kick();
  };

  Hero.prototype.kick = function () {
    var self = this;
    if (this.raf) return;
    var tick = function () {
      var diff = self.pT - self.p;
      var eps = self.mob ? 0.0008 : 0.0002;
      if (reduced || Math.abs(diff) < eps) { self.p = self.pT; self.render(self.p); self.raf = null; return; }
      self.p += diff * (self.mob ? 0.3 : 0.16);
      self.render(self.p);
      self.raf = requestAnimationFrame(tick);
    };
    this.raf = requestAnimationFrame(tick);
  };

  Hero.prototype.chapterP = function (k) { return this.CH0 + this.CHL * k + this.CHL * 0.55; };

  Hero.prototype.scrollForP = function (p) {
    return this.root.getBoundingClientRect().top + window.pageYOffset + p * (this.root.offsetHeight - this.H);
  };

  /* défilement animé (clic sur le plugin, flèche « Ensuite ») */
  Hero.prototype.glideTo = function (k) {
    var self = this;
    var start = window.pageYOffset, target = this.scrollForP(this.chapterP(k));
    var dist = target - start;
    if (Math.abs(dist) < 4) return;
    if (reduced) { window.scrollTo(0, target); return; }
    var dur = Math.min(3600, Math.max(900, Math.abs(dist) * 1.2));
    var id = ++this.autoId, t0 = null;
    var step = function (now) {
      if (self.autoId !== id) return;
      if (t0 === null) t0 = now;
      var t = Math.min(1, (now - t0) / dur);
      var e = t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2;
      window.scrollTo(0, start + dist * e);
      if (t < 1) requestAnimationFrame(step);
    };
    requestAnimationFrame(step);
  };

  /* arrivée directe (boutons Acheter) */
  Hero.prototype.jumpTo = function (k) {
    var self = this;
    this.autoId++;
    withVeil(function () {
      var tp = self.chapterP(k);
      window.scrollTo(0, self.scrollForP(tp));
      self.p = self.pT = tp;
      self.panelArr = [false, false, false, false, false];
      self.panels.forEach(function (el) { el.classList.remove('mi-arrive'); });
      self.render(tp);
      if (self.pulse && !reduced) {
        self.pulse.classList.remove('mi-plugpulse');
        void self.pulse.offsetWidth;
        self.pulse.classList.add('mi-plugpulse');
      }
    });
  };

  Hero.prototype.next = function () {
    var p = this.p;
    if (p < this.CH0 - 0.02) { this.glideTo(0); return; }
    if (this.fIdx < this.NCH - 1) { this.glideTo(this.fIdx + 1); return; }
    goSection('mi-demo');
  };

  Hero.prototype.bind = function () {
    var self = this;
    this.plug.addEventListener('click', function () { self.next(); });
    if (this.nextBtn) this.nextBtn.addEventListener('click', function () { self.next(); });
    if (this.hintBtn) this.hintBtn.addEventListener('click', function () { self.glideTo(0); });
    this.dots.forEach(function (d) { d.addEventListener('click', function () { self.glideTo(Number(d.getAttribute('data-mi-dot'))); }); });
    var stop = function () { self.autoId++; };
    window.addEventListener('wheel', stop, { passive: true });
    window.addEventListener('touchstart', stop, { passive: true });
  };

  Hero.prototype.render = function (p) {
    var CH0 = this.CH0, CHL = this.CHL, NCH = this.NCH, mob = this.mob;
    var aR = ease(p / 0.17);                 // le 360
    var ex = ease((p - 0.14) / 0.1);         // démontage
    var f = 0;
    if (p > CH0) {
      var seg = (p - CH0) / CHL;
      var kk = Math.min(NCH - 1, Math.floor(seg));
      var fr = seg - kk;
      f = kk === 0 ? 0 : (kk - 1) + ease(fr / 0.45);
      if (seg >= NCH) f = NCH - 1;
    }
    var sc = this.startBase + (this.endSc - this.startBase) * ex;
    var target = this.plugY + (this.cy - this.plugY) * aR;
    var tx = this.endX * ex;
    var ty = (target + (this.endY - target) * ex) - this.plugY;
    var rk = ease(clamp(f - 3, 0, 1));
    var fv = f <= 3 ? f : 3 - 3 * rk;        // à la fin, retour à la vue de la partie Achat
    var ry = -28 + aR * 358 + ex * 12;
    var rx = 16 - aR * 4 - ex * 2;
    var spread = { face: [12, 300], frame: [7, 150], pcb: [0, 0], hs: [-6, -150], back: [-12, -300] };
    var order = ['face', 'frame', 'pcb', 'hs', 'back'];
    var gz = 0;
    order.forEach(function (k, i) { var w = clamp(1 - Math.abs(fv - i), 0, 1); gz += w * (300 - spread[k][1]); });
    gz *= ex;

    this.plug.style.transform = 'translate(' + tx.toFixed(1) + 'px,' + ty.toFixed(1) + 'px) scale(' + sc.toFixed(4) + ')';
    this.d3.style.transform = 'rotateX(' + rx.toFixed(2) + 'deg) rotateY(' + ry.toFixed(2) + 'deg) translateZ(' + gz.toFixed(1) + 'px)';

    var opIn = ease((p - 0.14) / 0.05);
    var self = this;
    order.forEach(function (k, i) {
      var z = spread[k][0] + (spread[k][1] - spread[k][0]) * ex;
      var act = clamp(1 - Math.abs(fv - i), 0, 1);
      var passed = clamp(fv - i, 0, 1);
      var holo = ex * (1 - act);
      var o = (1 - holo * 0.55) * (1 - ease(passed * 1.15));
      if (k !== 'face' && k !== 'back') o = o * opIn;
      var el = self.pieces[k];
      var vis = o <= 0.003 ? 'hidden' : 'visible';
      if (el) {
        el.style.transform = 'translate3d(0,0,' + z.toFixed(1) + 'px)';
        el.style.opacity = o.toFixed(3);
        el.style.visibility = vis;
      }
      if (k === 'back' && self.pieces.backout) {
        self.pieces.backout.style.transform = 'translate3d(0,0,' + z.toFixed(1) + 'px) rotateY(180deg)';
        self.pieces.backout.style.visibility = vis;
      }
    });

    var edgeOp = 1 - ease((p - 0.14) / 0.06);
    this.edgesBox.style.display = edgeOp > 0.001 ? '' : 'none';
    this.edgesBox.style.opacity = edgeOp.toFixed(3);

    // ambiances et fondu
    for (var e = 0; e < NCH; e++) if (this.envs[e]) this.envs[e].style.opacity = (clamp(1 - Math.abs(f - e), 0, 1) * ex).toFixed(3);
    if (this.fade) this.fade.style.opacity = Math.max(1 - ex, ease((f - 3.4) / 0.6)).toFixed(3);

    // titre et indication
    if (this.intro) {
      this.intro.style.opacity = (1 - ease(p / 0.12)).toFixed(3);
      this.intro.style.transform = 'translateY(' + (-p * 300).toFixed(1) + 'px)';
    }
    if (this.hint) {
      this.hint.style.opacity = (1 - ease(p / 0.05)).toFixed(3);
      this.hint.style.pointerEvents = p < 0.04 ? 'auto' : 'none';
    }

    // textes des pièces
    var panelIn = ease((p - 0.2) / 0.05);
    for (var pi = 0; pi < NCH; pi++) {
      var el = this.panels[pi];
      if (!el) continue;
      var dlt = f - pi;
      var po = clamp(1 - Math.abs(dlt) * 2.2, 0, 1) * panelIn;
      el.style.opacity = po.toFixed(3);
      el.style.visibility = po > 0.003 ? 'visible' : 'hidden';
      el.style.pointerEvents = po > 0.6 ? 'auto' : 'none';
      el.style.transform = 'translateY(calc(' + this.panelShift + ' + ' + (-dlt * 60).toFixed(1) + 'px))';
      var want = po > 0.01;
      if (want !== this.panelArr[pi]) {
        this.panelArr[pi] = want;
        el.classList.toggle('mi-arrive', want);
      }
    }

    // repère de navigation
    var fIdx = Math.round(f);
    if (this.prog) {
      this.prog.style.opacity = panelIn.toFixed(3);
      this.prog.style.pointerEvents = panelIn > 0.5 ? 'auto' : 'none';
    }
    if (fIdx !== this.fIdx) {
      this.fIdx = fIdx;
      var acc = this.accents[fIdx] || '#8fb8ff';
      if (this.plab) { this.plab.textContent = this.labels[fIdx] || ''; this.plab.style.color = acc; }
      if (this.nextLabel) this.nextLabel.textContent = fIdx < NCH - 1 ? (this.labels[fIdx + 1] || '') : this.nextEnd;
      this.dots.forEach(function (d, i) {
        var bar = d.firstElementChild, on = i === fIdx;
        d.setAttribute('aria-label', self.labels[i] || ('Partie ' + (i + 1)));
        if (!bar) return;
        bar.style.width = on ? '26px' : '6px';
        bar.style.background = on ? (self.accents[i] || acc) : 'rgba(170,185,220,0.32)';
        bar.style.boxShadow = on ? '0 0 12px ' + (self.accents[i] || acc) : 'none';
      });
    }
  };

  /* ---------------------------------------------------------
     Apparitions au défilement
     --------------------------------------------------------- */
  function initReveal() {
    var els = [].slice.call(document.querySelectorAll('[data-mi-reveal]'));
    if (!els.length) return;
    if (!document.body.classList.contains('mi-reveal-on') || designMode || reduced || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('mi-arrive'); });
      return;
    }
    els.forEach(function (el) { el.classList.add('mi-wait'); });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) {
          var el = en.target;
          if (el.classList.contains('mi-wait')) { el.classList.remove('mi-wait'); el.classList.add('mi-arrive'); }
          io.unobserve(el);
        }
      });
    }, { rootMargin: '0px 0px -20% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------------------------------------------------------
     Lecteur avant / après
     --------------------------------------------------------- */
  function Player(root) {
    var self = this;
    this.root = root;
    this.demos = [].slice.call(root.querySelectorAll('[data-mi-demo]')).map(function (b) {
      return { btn: b, raw: b.getAttribute('data-raw'), wet: b.getAttribute('data-wet') };
    });
    this.orb = root.querySelector('[data-mi-orb]');
    this.glow = root.querySelector('[data-mi-orbglow]');
    this.rings = [].slice.call(root.querySelectorAll('[data-mi-ring]'));
    this.progLine = root.querySelector('[data-mi-progline]');
    this.state = root.querySelector('[data-mi-state]');
    this.time = root.querySelector('[data-mi-time]');
    this.range = root.querySelector('[data-mi-range]');
    this.fill = root.querySelector('[data-mi-fill]');
    this.amb = document.querySelector('[data-mi-amb]');
    this.labels = { raw: root.getAttribute('data-label-raw') || 'Voix brute', full: root.getAttribute('data-label-full') || '100 % MonInge', suffix: root.getAttribute('data-label-suffix') || '% MonInge' };
    this.m = Number(this.range ? this.range.value : 0) / 100;
    this.cur = 0;
    this.playing = false;
    this.raw = new Audio(); this.wet = new Audio();
    [this.raw, this.wet].forEach(function (a) { a.preload = 'none'; a.loop = true; a.crossOrigin = 'anonymous'; a.setAttribute('playsinline', ''); });
    this.demos.forEach(function (d, i) { d.btn.addEventListener('click', function () { self.pick(i); }); });
    if (this.orb) this.orb.addEventListener('click', function () { self.toggle(); });
    if (this.range) this.range.addEventListener('input', function () { self.m = Number(self.range.value) / 100; self.applyMix(); self.paint(); });
    this.raw.addEventListener('timeupdate', function () { self.onTime(); });
    this.pick(0, true);
    this.paint();
  }

  Player.prototype.pick = function (i, silent) {
    var d = this.demos[i];
    this.demos.forEach(function (x, j) { x.btn.classList.toggle('is-on', j === i); x.btn.setAttribute('aria-pressed', j === i ? 'true' : 'false'); });
    if (!d) return;
    var was = this.playing && !silent;
    this.pause();
    this.cur = i;
    this.raw.src = d.raw || d.wet || '';
    this.wet.src = d.wet || d.raw || '';
    this.raw.currentTime = 0;
    this.onTime();
    if (was) this.play();
  };

  Player.prototype.canWebAudio = function () {
    var ok = function (u) { if (!u) return true; try { var url = new URL(u, location.href); return url.origin === location.origin || /(^|\.)shopify\.com$|shopifycdn\.(com|net)$/.test(url.hostname); } catch (e) { return false; } };
    return !!(window.AudioContext || window.webkitAudioContext) && ok(this.raw.src) && ok(this.wet.src);
  };

  Player.prototype.ensureGraph = function () {
    if (this.graphTried) return;
    this.graphTried = true;
    if (!this.canWebAudio()) return;
    try {
      var Ctx = window.AudioContext || window.webkitAudioContext;
      this.ctx = new Ctx();
      this.gRaw = this.ctx.createGain(); this.gWet = this.ctx.createGain();
      this.ctx.createMediaElementSource(this.raw).connect(this.gRaw).connect(this.ctx.destination);
      this.ctx.createMediaElementSource(this.wet).connect(this.gWet).connect(this.ctx.destination);
    } catch (e) { this.ctx = null; }
  };

  Player.prototype.applyMix = function () {
    var m = this.m;
    // fondu « à puissance constante » entre les deux voix
    var gr = Math.cos(m * Math.PI / 2), gw = Math.sin(m * Math.PI / 2);
    if (this.ctx && this.gRaw) {
      this.gRaw.gain.value = gr; this.gWet.gain.value = gw;
      this.raw.muted = false; this.wet.muted = false;
    } else if (Player.volumeWorks()) {
      this.raw.volume = gr; this.wet.volume = gw;
      this.raw.muted = false; this.wet.muted = false;
    } else {
      // sur iPhone le volume ne se règle pas : on fait entendre la voix dominante
      this.raw.muted = m >= 0.5; this.wet.muted = m < 0.5;
    }
  };

  Player.volumeWorks = function () {
    if (Player._vol === undefined) { try { var a = new Audio(); a.volume = 0.5; Player._vol = Math.abs(a.volume - 0.5) < 0.01; } catch (e) { Player._vol = false; } }
    return Player._vol;
  };

  Player.prototype.play = function () {
    var self = this;
    if (!this.raw.src) return;
    this.ensureGraph();
    if (this.ctx && this.ctx.state === 'suspended') this.ctx.resume();
    this.applyMix();
    this.wet.currentTime = this.raw.currentTime || 0;
    var a = this.raw.play(), b = this.wet.play();
    this.playing = true;
    Promise.all([a, b].map(function (x) { return x && x.catch ? x.catch(function () {}) : x; })).then(function () { self.wet.currentTime = self.raw.currentTime; });
    this.paint();
  };

  Player.prototype.pause = function () {
    this.raw.pause(); this.wet.pause();
    this.playing = false;
    this.paint();
  };

  Player.prototype.toggle = function () { if (this.playing) this.pause(); else this.play(); };

  Player.prototype.onTime = function () {
    var r = this.raw, d = r.duration || 0, t = r.currentTime || 0;
    if (this.playing && Math.abs(this.wet.currentTime - t) > 0.12) this.wet.currentTime = t;
    var pos = d ? t / d : 0;
    if (this.progLine) this.progLine.setAttribute('stroke-dasharray', (917 * pos).toFixed(1) + ' 918');
    var fmt = function (x) { x = Math.floor(x || 0); return Math.floor(x / 60) + ':' + (x % 60 < 10 ? '0' : '') + (x % 60); };
    if (this.time) this.time.textContent = d ? fmt(t) + ' / ' + fmt(d) : '';
  };

  Player.prototype.paint = function () {
    var m = this.m;
    var mix = function (c0, c1, a) { return 'rgba(' + Math.round(c0[0] + (c1[0] - c0[0]) * m) + ',' + Math.round(c0[1] + (c1[1] - c0[1]) * m) + ',' + Math.round(c0[2] + (c1[2] - c0[2]) * m) + ',' + a.toFixed(3) + ')'; };
    var r0 = [41, 59, 64, 36, 44, 58, 55, 42], shape = '';
    for (var i = 0; i < 8; i++) shape += (r0[i] + (50 - r0[i]) * m).toFixed(1) + '%' + (i === 3 ? ' / ' : ' ');
    if (this.orb) {
      this.orb.style.borderRadius = shape;
      this.orb.style.background = 'radial-gradient(circle at 35% 30%, ' + mix([120, 126, 140], [150, 190, 255], 0.9) + ', ' + mix([58, 62, 74], [47, 107, 240], 1) + ' 55%, ' + mix([28, 30, 36], [16, 36, 96], 1) + ' 100%)';
      this.orb.style.boxShadow = '0 0 ' + Math.round(20 + 70 * m) + 'px ' + mix([60, 64, 76], [47, 107, 240], 0.35 + 0.35 * m) + ', inset 0 2px 0 rgba(255,255,255,0.18)';
      this.orb.classList.toggle('is-playing', this.playing);
      this.orb.setAttribute('aria-pressed', this.playing ? 'true' : 'false');
    }
    if (this.glow) { this.glow.style.background = 'radial-gradient(closest-side, ' + mix([90, 96, 110], [47, 107, 240], 0.10 + 0.25 * m) + ', rgba(0,0,0,0))'; this.glow.style.transform = 'scale(' + (0.8 + 0.4 * m).toFixed(3) + ')'; }
    var ringCol = mix([140, 146, 160], [143, 184, 255], 0.6), playing = this.playing;
    this.rings.forEach(function (r) { r.style.borderColor = ringCol; r.classList.toggle('on', playing); });
    if (this.progLine) this.progLine.setAttribute('stroke', mix([160, 166, 180], [143, 184, 255], 1));
    if (this.state) {
      var pc = Math.round(m * 100);
      this.state.textContent = pc <= 2 ? this.labels.raw : pc >= 98 ? this.labels.full : pc + ' ' + this.labels.suffix;
      this.state.style.color = mix([150, 156, 170], [168, 196, 255], 1);
    }
    if (this.fill) this.fill.style.width = (m * 100) + '%';
    if (this.amb) this.amb.style.background = 'radial-gradient(closest-side, rgba(' + Math.round(80 + (47 - 80) * m) + ',' + Math.round(90 + (107 - 90) * m) + ',' + Math.round(120 + (240 - 120) * m) + ',' + (0.10 + 0.10 * m).toFixed(3) + '), rgba(0,0,0,0))';
  };

  /* ---------------------------------------------------------
     Vidéos : la vidéo se charge seulement au clic
     --------------------------------------------------------- */
  function initVideos(scope) {
    [].slice.call(scope.querySelectorAll('[data-mi-video]')).forEach(function (btn) {
      if (btn._mi) return; btn._mi = true;
      var open = function () {
        if (btn._open) return; btn._open = true;
        var tpl = btn.querySelector('template');
        if (!tpl) return;
        var node = tpl.content.cloneNode(true);
        btn.innerHTML = '';
        btn.appendChild(node);
        btn.style.cursor = 'default';
        btn.removeAttribute('role'); btn.removeAttribute('tabindex');
        var v = btn.querySelector('video');
        if (v && v.play) { var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); }
      };
      btn.addEventListener('click', open);
      btn.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(); } });
    });
  }

  /* ---------------------------------------------------------
     Liens du menu, boutons Acheter, menu téléphone, barre d'achat
     --------------------------------------------------------- */
  function initNav() {
    document.addEventListener('click', function (e) {
      var go = e.target.closest('[data-mi-go]');
      if (go) {
        var id = go.getAttribute('data-mi-go');
        if (id === 'mi-top' ? !!hero : !!document.getElementById(id)) {
          e.preventDefault();
          closeDrawer();
          goSection(id);
          if (history.replaceState) history.replaceState(null, '', location.pathname + location.search);
        }
        return;
      }
      var jump = e.target.closest('[data-mi-jump]');
      if (jump && hero) {
        e.preventDefault();
        closeDrawer();
        hero.jumpTo(Number(jump.getAttribute('data-mi-jump')) || 0);
      }
    });
    var burger = document.querySelector('[data-mi-burger]');
    var drawer = document.querySelector('[data-mi-drawer]');
    function closeDrawer() { if (drawer) { drawer.classList.remove('is-open'); if (burger) burger.setAttribute('aria-expanded', 'false'); } }
    if (burger && drawer) burger.addEventListener('click', function () {
      var open = !drawer.classList.contains('is-open');
      drawer.classList.toggle('is-open', open);
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  function initSticky() {
    var bar = document.querySelector('[data-mi-sticky]');
    if (!bar) return;
    var h = document.querySelector('[data-mi-hero]');
    var check = function () {
      var past = h ? h.getBoundingClientRect().bottom < window.innerHeight * 0.6 : window.pageYOffset > 400;
      bar.classList.toggle('is-on', past);
    };
    window.addEventListener('scroll', check, { passive: true });
    check();
  }

  /* ---------------------------------------------------------
     Démarrage
     --------------------------------------------------------- */
  function initSections(scope) {
    var h = scope.querySelector('[data-mi-hero]');
    if (h) hero = new Hero(h);
    [].slice.call(scope.querySelectorAll('[data-mi-player]')).forEach(function (p) { if (!p._mi) { p._mi = new Player(p); } });
    initVideos(scope);
  }

  function boot() {
    initSections(document);
    initNav();
    initReveal();
    initSticky();
    window.addEventListener('scroll', function () { if (hero) hero.onScroll(); }, { passive: true });
    var rt = null;
    window.addEventListener('resize', function () {
      clearTimeout(rt);
      rt = setTimeout(function () { if (hero) { hero.layout(); hero.onScroll(); hero.fIdx = -1; hero.render(hero.p); } }, 120);
    });
    // arrivée avec une ancre dans l'adresse (ex. depuis une autre page)
    var hash = location.hash.replace('#', '');
    if (hash) {
      setTimeout(function () {
        if (hash === 'mi-buy' && hero) hero.jumpTo(0);
        else if (/^mi-/.test(hash)) goSection(hash);
      }, 60);
    }
  }

  // éditeur de thème Shopify : on relance quand une section est modifiée
  document.addEventListener('shopify:section:load', function (e) {
    initSections(e.target);
    [].slice.call(e.target.querySelectorAll('[data-mi-reveal]')).forEach(function (el) { el.classList.add('mi-arrive'); });
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
